





















































import { defineComponent, reactive, toRefs } from "@vue/composition-api";
import Alerts, { AlertType } from "@/code/alerts";
import { HttpPOST } from "@/code/Utils";

export default defineComponent({
  name: "Login",
  setup(props, context) {
    const data = reactive({
      email: "",
      password: "",
    });

    const Login = async () => {
      const alert = document.querySelector(".pol-alert");
      if (alert) alert.classList.remove("show");
      // context.root.$store.commit("ChangeLoader", true);
      const response = (await HttpPOST(`<soap:Envelope xmlns:soap="http://www.w3.org/2003/05/soap-envelope" xmlns:tem="http://tempuri.org/">
                                          <soap:Header/>
                                          <soap:Body>
                                              <tem:Autenticar_DDJJ>
                                                <!--Optional:-->
                                                <tem:userName>${data.email}</tem:userName>
                                                <!--Optional:-->
                                                <tem:password>${data.password}</tem:password>
                                              </tem:Autenticar_DDJJ>
                                          </soap:Body>
                                        </soap:Envelope>`, null)) as XMLHttpRequest;      
      const Xml = response.responseXML;
      console.log(Xml);
      // const message = Xml.getElementsByTagName("Data")[0].textContent;
      const message = Xml.getElementsByTagName("Data").length > 0 ? Xml.getElementsByTagName("Data")[0].textContent : Xml.getElementsByTagName("HasErrors")[0].textContent;
      console.log(message);
      if (message.indexOf("Login: OK") != -1) {
        const msg = message.split("-");
        const nameindex = msg[1].indexOf("Nombre:");
        let name = msg[1].slice(nameindex + 7).trim();
        let lastname = msg[1].slice(10, nameindex).trim();
        lastname = lastname ? lastname + ", " : lastname;
        const formatName = lastname + name;
        // const companyName = msg[4]
        //   .slice(13)
        //   .trim()
        //   .split(",");
        const companyName = msg[4]
           .slice(13)
            .trim()
           .split(",");
        const formatCName =
          companyName.length > 1
            ? companyName[0].trim() + ", " + companyName[1].trim()
            : companyName[0];
        const session = {
          user: msg[0].slice(12).trim(),
          companyCode: parseInt(msg[3].slice(13).trim()).toString(),
          name: formatName,
          companyName:
            formatCName.toLowerCase().indexOf(formatName.toLowerCase()) == -1
              ? formatCName
              : "",
        };

        await sessionStorage.setItem("UserLogin", JSON.stringify(session));
        context.root.$store.commit("setSession", session);
        context.root.$router.push("./home").then(() => {
          data.email = "";
          data.password = "";
        });

      } else {
        Alerts.Throw(
          `El Usuario y/o Contraseña ingresado no es valido.`,
          AlertType.Danger,
          false,
          6000
        );
      }
    };

    const ShowHidePassword = () => {
      const a = document.getElementById("ShowHide");
      const icon = document.querySelector("#ShowHide i");
      const input = document.getElementById("password");
      const atr = input.getAttribute("type");
      const contains = icon.classList.contains("fa-eye-slash");
      const title = a.getAttribute("title");
      a.setAttribute(
        "title",
        title == "Mostrar Contraseña"
          ? "Ocultar Contraseña"
          : "Mostrar Contraseña"
      );
      icon.classList.remove(contains ? "fa-eye-slash" : "fa-eye");
      icon.classList.add(contains ? "fa-eye" : "fa-eye-slash");
      input.setAttribute("type", atr == "password" ? "text" : "password");
    };

    return {
      ...toRefs(data),
      Login,
      ShowHidePassword,
    };
  },
});
